import ProsAndCons from './pros-and-cons'
import { useEntity } from '@uswitch/ev-utils/context/selectors'

export default ({ cons, pros, ...rest }) => (
  <ProsAndCons cons={useEntity(cons)} pros={useEntity(pros)} {...rest} />
)
